var map = {
	"./first/API.svg": "n1NB",
	"./first/Account.svg": "qlWX",
	"./first/Calendar.svg": "c6vB",
	"./first/Calm.svg": "wwJY",
	"./first/Card.svg": "WnwA",
	"./first/CheckInCircle.svg": "Sw8B",
	"./first/CheckInStar.svg": "YM/n",
	"./first/Copyright.svg": "/PHo",
	"./first/CrossWithPointer.svg": "Jef2",
	"./first/CurrencyControl.svg": "wvIJ",
	"./first/Delivery.svg": "wQjp",
	"./first/Design.svg": "XUsq",
	"./first/EscrowAccount.svg": "BRBC",
	"./first/Flag.svg": "da/I",
	"./first/GroceryTrolley.svg": "I7IG",
	"./first/Happy.svg": "jgGR",
	"./first/Hat.svg": "bLYC",
	"./first/Heart.svg": "RfFt",
	"./first/Home.svg": "PooB",
	"./first/Lightning.svg": "EN1q",
	"./first/Monitor.svg": "Y1BJ",
	"./first/PaymentBot.svg": "5klN",
	"./first/Question.svg": "YhKj",
	"./first/Receipt.svg": "iKRO",
	"./first/SBP-cashback.svg": "/qna",
	"./first/SBP-earth.svg": "VjVb",
	"./first/SBP-freelance.svg": "zgOL",
	"./first/SBP-phone.svg": "95i9",
	"./first/SBP.svg": "cokk",
	"./first/SBP1.svg": "jtKn",
	"./first/SBP2.svg": "vnSn",
	"./first/SBPCheck.svg": "agub",
	"./first/Settings.svg": "TjEI",
	"./first/Shield.svg": "hVLm",
	"./first/ShieldHR.svg": "R0IL",
	"./first/Smile.svg": "ujW7",
	"./first/SplitPayment.svg": "ghsd",
	"./first/Training.svg": "Dq62",
	"./first/UserCheck.svg": "IQWD",
	"./first/VED.svg": "xu/N",
	"./first/Wallet.svg": "yP4a",
	"./first/World.svg": "10R/",
	"./first/botPaymentDelivery.svg": "YXHe",
	"./first/botPaymentGames.svg": "ELIv",
	"./first/botPaymentsOnlineShopping.svg": "Ow6C",
	"./first/iconSimpleForBuyer.svg": "BCW9",
	"./first/onlineBanking.svg": "a3vC",
	"./first/splitPayments.svg": "aLhP",
	"./second/API.svg": "6V+9",
	"./second/Account.svg": "38P1",
	"./second/Building.svg": "YM+5",
	"./second/Card.svg": "5fBo",
	"./second/CheckInStar.svg": "HkSJ",
	"./second/EscrowAccount.svg": "hPLu",
	"./second/Flag.svg": "Hd6D",
	"./second/FullCheck.svg": "Gh+7",
	"./second/ImageNext.svg": "wx3a",
	"./second/ImagePrev.svg": "hIpt",
	"./second/Like.svg": "eLQv",
	"./second/Money.svg": "u/75",
	"./second/Notebook.svg": "rE/M",
	"./second/PaymentBot.svg": "71K+",
	"./second/SBP.svg": "FoNo",
	"./second/SBPCheck.svg": "gdp0",
	"./second/Smile.svg": "WDE0",
	"./second/SplitPayment.svg": "Ez3Z",
	"./second/StarCheck.svg": "oeo0",
	"./second/State.svg": "VUoP",
	"./second/Suitcase.svg": "rP3s",
	"./second/Translate.svg": "6yff",
	"./second/UserCheck.svg": "s8X5",
	"./second/VED.svg": "ZqsR",
	"./second/World.svg": "2GAi",
	"./second/botPaymentAuditory.svg": "p1wB",
	"./second/botPaymentNativeForm.svg": "whX7",
	"./second/botPaymentNoSite.svg": "ZYcD",
	"./second/botPaymentSecurity.svg": "d4lP",
	"./second/botPaymentTestMode.svg": "3Zyx",
	"./second/botPaymentTips.svg": "pJjq",
	"./second/botPaymentsInfoproducts.svg": "0TZu",
	"./second/howStartFirst.svg": "g+nl",
	"./second/howStartSecond.svg": "dcQ2",
	"./second/iconSimpleForCompany.svg": "lydj",
	"./second/onlineBanking.svg": "c2nW"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fo5W";